"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePostObjectiveComment = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const react_query_1 = require("react-query");
const ObjectivesClient_1 = require("src/client/ObjectivesClient");
const usePostObjectiveComment = (objectiveId, options) => {
    return (0, react_query_1.useMutation)(async (body) => {
        const response = await (0, ObjectivesClient_1.createComment)(objectiveId, body);
        if (response?.isSuccess) {
            return response;
        }
        throw response;
    }, options);
};
exports.usePostObjectiveComment = usePostObjectiveComment;
